'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _moment = require('moment');
var _moment2 = _interopRequireDefault(_moment);
var _reactI18next = require('react-i18next');
var _misc = require('../helpers/misc');
var _ResponsiveModes = require('../constants/ResponsiveModes');
var _Grid = require('@material-ui/core/Grid');
var _Grid2 = _interopRequireDefault(_Grid);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var styles = {
  participantInfo: {
    paddingTop: '1rem',
    wordWrap: 'break-word'
  },
  modalField: {
    fontWeight: 'bold',
    padding: '1rem 2rem 0rem 2rem',
    '& p': {
      color: '#494949'
    }
  },
  modalAnswer: {
    padding: '0 2rem',
    '& p': {
      color: '#494949'
    }
  },
  participant: {
    '& .modal-picture-wrapper': {
      '& .modal-picture': {
        height: '6rem',
        width: '9rem',
        margin: '1rem 0 0 0rem',
        objectFit: 'contain'
      }
    }
  }
};
var B2BModalContent = function (_Component) {
  _inherits(B2BModalContent, _Component);
  function B2BModalContent(props) {
    _classCallCheck(this, B2BModalContent);
    var _this = _possibleConstructorReturn(this, (B2BModalContent.__proto__ || Object.getPrototypeOf(B2BModalContent)).call(this, props));
    _this.renderField = function (alias, field) {
      if (!!alias) return alias;
      switch (field) {
        case 'first_name':
          return 'First name';
        case 'last_name':
          return 'Last name';
        case 'job_title':
          return 'Job Title';
        default:
          return field;
      }
    };
    return _this;
  }
  _createClass(B2BModalContent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;
      if (this.props.i18n.language === 'es') _moment2.default.updateLocale('es', {
        ordinal: '%d'
      });
      var _props = this.props,
        classes = _props.classes,
        logoURL = _props.logoURL,
        attendeeAnswers = _props.attendeeAnswers,
        attendeeFields = _props.attendeeFields,
        participantAnswers = _props.participantAnswers,
        participantFields = _props.participantFields,
        responsiveMode = _props.responsiveMode;
      var spacing = responsiveMode === _ResponsiveModes.DESKTOP ? 24 : 8;
      var column_size = responsiveMode === _ResponsiveModes.DESKTOP ? 4 : responsiveMode === _ResponsiveModes.TABLET ? 6 : 12;
      return _react2.default.createElement('div', {
        className: classes.participant
      }, _react2.default.createElement('div', {
        className: 'modal-picture-wrapper'
      }, _react2.default.createElement('img', {
        className: 'modal-picture',
        src: logoURL
      })), _react2.default.createElement(_Grid2.default, {
        container: true,
        className: classes.grid,
        spacing: spacing,
        direction: 'row',
        justify: 'flex-start',
        alignItems: 'stretch'
      }, Object.keys(attendeeAnswers).filter(function (answerId) {
        return !!attendeeFields[answerId] && !!attendeeAnswers[answerId];
      }).map(function (answerId) {
        return _react2.default.createElement(_Grid2.default, {
          item: true,
          xs: column_size,
          key: answerId,
          className: classes.participantInfo
        }, _react2.default.createElement('div', {
          className: classes.modalField
        }, _this2.renderField(attendeeFields[answerId].alias, attendeeFields[answerId].name)), _react2.default.createElement('div', {
          className: classes.modalAnswer
        }, (0, _misc.isObject)(attendeeAnswers[answerId]) ? attendeeAnswers[answerId].constructor === Array ? attendeeAnswers[answerId].join(', ') : _react2.default.createElement('a', {
          href: attendeeAnswers[answerId].originalUrl,
          target: '_blank'
        }, attendeeAnswers[answerId].originalUrl) : attendeeAnswers[answerId]));
      }), Object.keys(participantAnswers).filter(function (answerId) {
        return !!participantFields[answerId] && !!participantAnswers[answerId];
      }).map(function (answerId) {
        return _react2.default.createElement(_Grid2.default, {
          item: true,
          xs: column_size,
          key: answerId,
          className: classes.participantInfo
        }, _react2.default.createElement('div', {
          className: classes.modalField
        }, participantFields[answerId].alias || participantFields[answerId].name), _react2.default.createElement('div', {
          className: classes.modalAnswer
        }, (0, _misc.isObject)(participantAnswers[answerId]) ? participantAnswers[answerId].constructor === Array ? participantAnswers[answerId].join(', ') : _react2.default.createElement('a', {
          href: participantAnswers[answerId].originalUrl,
          target: '_blank'
        }, participantAnswers[answerId].originalUrl) : participantAnswers[answerId]));
      })));
    }
  }]);
  return B2BModalContent;
}(_react.Component);
exports.default = (0, _reactJss2.default)(styles)((0, _reactI18next.translate)('Misc')(B2BModalContent));